export default __webpack_public_path__ + "static/media/hoppia_events_02.c429c8a9.png";